import { useTranslation } from 'react-i18next';
import { LinkIcon, PlusIcon } from '@heroicons/react/24/outline';

import { Button } from 'components/Form/Button/Button';

type NoConnectionProps = {
  onRequestConnection: () => void;
};

export const NoConnection = ({ onRequestConnection }: NoConnectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-14">
      <div className="mx-auto flex w-[600px] flex-col items-center justify-center gap-6 px-8 text-center">
        <div className="rounded-full bg-procuros-grey p-5">
          <LinkIcon className="size-16" />
        </div>
        <h3 className="text-lg font-bold text-gray-900">{t('partners:connectionDetails.noConnection.title')}</h3>
        <p className="text-sm text-gray-500">{t('partners:connectionDetails.noConnection.description')}</p>
        <Button onClick={onRequestConnection} LeftIcon={PlusIcon} analyticsId="partners:request_connection_empty_state">
          {t('partners:connectionDetails.noConnection.cta')}
        </Button>
      </div>
    </div>
  );
};
